import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useInfiniteQuery } from '@tanstack/react-query'

import type { RecipientGroup } from '../mutations/useSendEmail'

export type EmailHistoryItem = {
  id: string
  sender_name: string | null
  subject: string
  title: string
  message_text: string
  recipient_emails: string[]
  groups: RecipientGroup[]
  recipients_count: number
  created_at: string
}

type EmailHistoryResponse = {
  count: number
  results: EmailHistoryItem[]
}

const PAGE_SIZE = 4

export const emailHistoryQueryKey = ['admin-email-history']

export function useEmailHistory() {
  return useInfiniteQuery({
    queryKey: emailHistoryQueryKey,
    initialPageParam: 0,
    queryFn: async ({ pageParam }) => {
      const res = await apiClient.get<EmailHistoryResponse>(
        BACK_OFFICE_PREFIX + 'admin-email/history/',
        { params: { limit: PAGE_SIZE, offset: pageParam } }
      )
      return res.data
    },
    getNextPageParam: (_lastPage, allPages) => {
      const loaded = allPages.reduce((n, p) => n + p.results.length, 0)
      const total = allPages[0]?.count ?? 0
      return loaded < total ? loaded : undefined
    }
  })
}
